module.exports = __webpack_public_path__ + "img/16.6016fd4e.jpg";